import { useEffect, useState } from 'react';

function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const narrow = window.innerWidth < 768;
  // Tablet (>= 768px com touch) vai pro desktop — só narrow + coarse é mobile
  return coarse && narrow;
}

/**
 * Detecta se o dispositivo atual é mobile.
 * Combina `pointer: coarse` (touch) + largura < 768px.
 * Tablet (>=768px com touch) retorna false — usa shell desktop.
 * Reage a resize e mudança de media query.
 */
export function useMobileDetection(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(isMobileViewport);

  useEffect(() => {
    const mq = window.matchMedia('(pointer: coarse)');

    function check() {
      setIsMobile(isMobileViewport());
    }

    mq.addEventListener('change', check);
    window.addEventListener('resize', check);

    return () => {
      mq.removeEventListener('change', check);
      window.removeEventListener('resize', check);
    };
  }, []);

  return isMobile;
}
